<template>
  <header class="HeaderBar">
    <img src="../../assets/logo-vzc.svg" alt="Verizon Connect" width="102" height="57">
    <a class="_linkButton" :href="linkButton[1]" target="_blank">{{linkButton[0]}}</a>
  </header>
</template>

<script>
  import content from "../../assets/stores.json"

  export default {
    name: 'HeaderBar',
    data() {
      return {
        linkButton: content.headerButton
      }
    }
  }
</script>
<style lang="scss">
  @import '../../assets/colors';

  .HeaderBar {

    box-sizing: border-box;
    width: 100%;
    padding: 12px 18px;
    background-color: white;
    border-bottom: thin solid $color-border-grey;
    display: flex;
    justify-content: space-between;

    ._linkButton {
      padding: 20px 28px;
      border-radius: 999px;
      color: white;
      background-color: $color-vzc-blue;
      font-weight: bold;
      font-size: 14px;
      text-decoration: none;
      transition: background-color 0.15s;
      &:hover {
        background-color: darken($color-vzc-blue, 5%)
      }
    }
  }
</style>
